import React from "react";
import ApplicationImage from "../assets/application-image.webp";
import ApplicationForm from "./ApplicationForm";
import languageStorage from "../lang/findLanguage";

export default function Application({ language }) {
  // languageStorage() === "tr" ? language[0].sections[2].keys[0].k0001 : language[1].sections[2].keys[0].k0001;

  return (
    <div className="application" id={languageStorage() === "tr" ? language[0].sections[11].keys[3].k0004 : language[1].sections[11].keys[3].k0004}>
      <div className="container ">
        <div className="application-content">
          <h3>{languageStorage() === "tr" ? language[0].sections[6].keys[0].k0001 : language[1].sections[6].keys[0].k0001}</h3>
          <p>{languageStorage() === "tr" ? language[0].sections[6].keys[1].k0002 : language[1].sections[6].keys[1].k0002}</p>
          <img className="img-fluid" src={ApplicationImage} alt="" width="100%" height="100%" />
        </div>
        <ApplicationForm language={language} />
      </div>
    </div>
  );
}
